import React from 'react';

export default function Button({
  children,
  type = 'button',
  variant = 'gold',   // 'gold' | 'blue' | 'outline' | 'ghost'
  loading = false,
  fullWidth = false,
  className = '',
  ...props
}) {
  const base = fullWidth ? 'w-full' : '';

  const variantClass = {
    gold:    'btn-gold',
    blue:    'btn-blue',
    outline: 'btn-outline',
    ghost:   'inline-flex items-center justify-center gap-2 rounded-2xl px-6 py-3.5 font-semibold tracking-wide transition-all duration-200 active:scale-95 text-white/70 hover:text-white hover:bg-white/08',
  }[variant] || 'btn-gold';

  return (
    <button
      type={type}
      disabled={loading || props.disabled}
      className={`${variantClass} ${base} ${className}`}
      {...props}
    >
      {loading ? (
        <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
      ) : children}
    </button>
  );
}
